module.exports = __webpack_public_path__ + "static/img/1.8bf4f8f9.png";